<template>
  <div class="row">
    <div class="col-4 d-flex justify-content-start align-items-center pagination_from-to">
      {{ name }} {{ page.from ?? 0 }} {{ trans('components.pagination.TO') }} {{ page.to ?? 0 }} {{ trans('components.pagination.FROM') }} {{ page.total }}
    </div>
    <div class="col-4 pagination_pages">
      <ul v-if="links.length > 3" class="pagination d-flex justify-content-center align-items-center mb-0">
        <template v-for="(link, p) in links" :key="p">
          <li
            v-if="link && link.label"
            :class="{
              active: link.active || page == link.label,
              disabled: (link.label == '<' && currentPage == 1) || (link.label == '>' && currentPage == page.last_page),
            }"
            class="page-item"
          >
            <button v-if="requestType == 'api'" class="page-link" type="button" @click="changePage(p)" style="--bs-pagination-active-bg: var(--primary-color); --bs-pagination-active-border-color: var(--primary-color);">
              {{ link.label }}
            </button>
            <Link v-if="requestType == 'inertia'" :href="link.url" class="page-link" v-text="link.label" style="--bs-pagination-active-bg: var(--primary-color); --bs-pagination-active-border-color: var(--primary-color);" />
          </li>
        </template>
      </ul>
    </div>
    <div class="col-4 d-flex justify-content-end align-items-center pagination_per-page">
      <select
        v-if="steps.length > 1"
        class="form-select form-select-sm w-auto me-2"
        @change="updatePerPage($event, route, routePrefix)"
      >
        <option v-for="(value, index) in steps" :key="index" :selected="perPage == value">
          {{ value }}
        </option>
      </select>
      <span v-if="steps.length === 1">{{ steps[0] }}&nbsp;</span>
      {{ name }} {{ trans('components.pagination.PER_PAGE') }}
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import usePagination from '@kanrisha/composables/usePagination';
import { ref } from 'vue';

export default {
  components: {
    Link,
  },
  props: {
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'Einträge' },
    steps: { type: Array, default: () => [10, 25, 50, 100] },
  },
  emits: ['update:perPage', 'trigger:refresh'],
  setup(props, { emit }) {
    const { currentPage, links, page, perPage, updatePerPage } = usePagination(props.resource);
    const requestType = ref(props.resource.meta.config.component.requestType ?? 'inertia');
    const resourceType = ref(props.resource.meta.resourceType);

    const changePage = async (p) => {
      let requestedPage = links.value[p].label;
      if (requestedPage === '<' || requestedPage === '>') {
        requestedPage = requestedPage === '<' ? '1' : props.resource.page.last_page;
      }
      let data = {};
      let parentType = props.resource.meta.relationInfo.parentType;
      let relation = props.resource.meta.relationInfo.name;

      await window.axios.request({
        url: `/${resourceType.value}/adjust?relation=${relation}&parent=${parentType}&page[number]=${p}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
        data,
      });
      emit('trigger:refresh', { data }, requestedPage);
    };

    return {
      changePage,
      currentPage,
      links,
      page,
      perPage,
      requestType,
      updatePerPage,
    };
  },
};
</script>
